// useArrivalInfo.js
import { useMemo } from 'react';

/**
 * Get UTM parameters from cookie
 * @returns {Object|null} UTM parameters from cookie or null if not found
 */
const getUTMFromCookie = () => {
  if (typeof document === 'undefined') return null;
  
  try {
    const cookies = document.cookie.split(';');
    const utmCookie = cookies.find(cookie => cookie.trim().startsWith('utm_params='));
    
    if (utmCookie) {
      const cookieValue = utmCookie.split('=')[1];
      return JSON.parse(decodeURIComponent(cookieValue));
    }
  } catch (error) {
    console.warn('Error parsing utm_params cookie:', error);
  }
  
  return null;
};

const useArrivalInfo = () => {
  const arrivalInfo = useMemo(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return null; //for SSR
    }
    
    const referrer = document.referrer;
    const urlParams = new URLSearchParams(window.location.search);
    
    // Get UTM parameters from cookie as fallback
    const cookieUTM = getUTMFromCookie();
    
    return {
      referrer: referrer,
      // Prioritize URL parameters, fallback to cookie values
      utmSource: urlParams.get('utm_source') || cookieUTM?.utm_source || null,
      utmMedium: urlParams.get('utm_medium') || cookieUTM?.utm_medium || null,
      utmCampaign: urlParams.get('utm_campaign') || cookieUTM?.utm_campaign || null,
      utmTerm: urlParams.get('utm_term') || cookieUTM?.utm_term || null,
      utmContent: urlParams.get('utm_content') || cookieUTM?.utm_content || null
    };
  }, []);

  return arrivalInfo;
};

export default useArrivalInfo;
